// Stub implementation - reactive repositories not currently used
import * as Layer from 'effect/Layer';
import * as Context from 'effect/Context';

export interface RepositoryEvent<T> {
  type: 'created' | 'updated' | 'deleted' | 'bulk-updated';
  entity: string;
  data: T | T[] | null;
  id?: string;
  timestamp: number;
}

// Create a stub RepositoryEventBus service
export class RepositoryEventBus extends Context.Tag('RepositoryEventBus')<
  RepositoryEventBus,
  {}
>() {}

// Create a stub layer that provides an empty implementation
export const RepositoryEventBusLive = Layer.succeed(RepositoryEventBus, {});

export abstract class ReactiveRepository<_T> {
  constructor(_config: any) {}

  abstract findAll(): any;
  abstract create(_data: any): any;
  abstract update(_id: string, _data: any): any;
  abstract delete(_id: string): any;

  subscribe(_callback: any) {
    return () => {};
  }
}